import { Button, Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import outOfTimeImg from "../../constants/images/OutOfTime.png";
import * as ROUTES from "../../constants/routes";

const OutOfDate = ({ isAfterToday }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Container>
      <Grid container style={{ textAlign: "center" }} alignItems="center" justify="center" direction="column">
        <Grid item xs={12} md={7} lg={6}>
          <Typography
            variant="h2"
            color="primary"
            style={{
              justifySelf: "center",
              marginTop: 64,
            }}
          >
            Reanibex Training
          </Typography>
          <Typography
            variant="h5"
            color="textSecondary"
            style={{
              justifySelf: "center",
              marginTop: 16,
              fontWeight: 200,
              fontSize: "1.9rem",
            }}
          >
            {isAfterToday ? t("el_plazo_de_inscripción_aun_no_se_ha_abierto") : t("outOfTime")}
          </Typography>
          <Button variant="outlined" color="primary" style={{ marginTop: 16 }} onClick={() => history.push(ROUTES.SIGN_IN)}>
            {t("home")}
          </Button>
        </Grid>
        <Grid item xs={12} md={6} lg={6} style={{ alignContent: "center", marginTop: "5vh" }}>
          <img src={outOfTimeImg} style={{ width: "100%" }} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default OutOfDate;
